import { BenModalFn } from '@/common/BenModalFn'
import { BenQuery } from './BenQuery'
import { BenFn } from '@/common/BenFn'
import { WimFn } from '@/components/service/WimFn'
import { BenView } from './BenView'
let _activeVideo = null as null | HTMLVideoElement
let _muted = false
let _volume = 0
let $win: HTMLElement | null = null
let $vCt: HTMLElement
export class BenVideo {
  static async init(dones) {
    let $close: HTMLElement | null = null
    const html = document.documentElement
    const isMobile = html.offsetWidth <= 800
    const $btnList = [] as HTMLElement[]
    if (!$win) {
      const res = _createWin(isMobile)
      $win = res.$div
      $close = res.$close
      $vCt = res.$vCt
    }
    await BenQuery.nextTick()
    $close?.addEventListener('click', async () => {
      WimFn.addTrack('VideoClose', {})
      BenView.setAction('vc')
      if (isMobile) html.style.setProperty('--video-height', '0px')
      $win?.classList.remove('show')
      const $v = $win?.querySelector('.body > video') as HTMLVideoElement
      if ($v) {
        $v.pause()
        await BenQuery.nextTick()
        $v.remove()
      }
      $btnList.forEach(async ($btn) => {
        await BenFn.sleep(1000)
        $btn.classList.remove('hide')
      })
    })
    const vTopHeight = $win.offsetHeight
    const $videoList = BenQuery.query('.c-video')
    $videoList.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      const $btn = _initVideo({ $video: $item, isMobile, vTopHeight })
      $btnList.push($btn)
    })
  }
}

function _initVideo(params: { $video: HTMLElement; isMobile: boolean; vTopHeight: number }) {
  const { $video, isMobile, vTopHeight } = params
  const src = $video.getAttribute('video-src') || 'aaa'
  const $btn = document.createElement('div')
  $btn.classList.add('play-btn')
  $btn.innerHTML = '<svg><use xlink:href="#icon-xiajiantou"></use></svg>'
  $video.prepend($btn)
  $video.addEventListener('click', async () => {
    WimFn.addTrack('OpenSource', { src })
    BenView.setAction('vo')
    // const $v = _createVideoElement({ src })
    if (isMobile) {
      document.documentElement.style.setProperty('--video-height', `${vTopHeight}px`)
    }
    $win?.classList.add('show')
    _activeVideo?.pause()
    _activeVideo?.remove()
    $vCt.innerHTML = `<video src="${src}"  playsinline controls autoplay preload="metadata"></video>`
    await BenQuery.sleep(100)
    const $v = $vCt.querySelector('video') as HTMLVideoElement
    $vCt.append($v)
    _activeVideo = $v
    $btn.classList.add('hide')
    // $v.controls = true
    $v.muted = _muted
    $v.volume = _volume
    // $v.autoplay = true
    // $v.preload = 'metadata'
    $v.addEventListener('volumechange', () => {
      if ($v.muted) {
        _muted = true
      } else {
        _muted = false
      }
    })
    $v.addEventListener('ended', () => {
      $btn.classList.remove('hide')
    })
    $v.addEventListener('pause', () => {
      $btn.classList.remove('hide')
    })
    $v.addEventListener('play', function () {
      WimFn.addTrack('VideoPlay', { src })
      BenView.setAction('vp')
      $btn.classList.add('hide')
    })
    $v.addEventListener('ended', async () => {
      $v.currentTime = 0
      $v.load()
      $btn.classList.remove('hide')
    })
    $v.addEventListener('volumechange', () => {
      _volume = $v.volume
    })
    if (isMobile) {
      document.documentElement.style.setProperty('--video-height', `${vTopHeight}px`)
    }
  })
  return $btn
}

function _createVideoElement(params: { src: string }) {
  const { src } = params
  const video = document.createElement('video')
  Object.assign(video, { src, muted: false, playsInline: true })
  video.controls = true
  return video
}

function _createWin(isMobile) {
  const $div = document.createElement('div')
  const tips = BenQuery.getWinValue('closeVideo')
  const btnHtml = isMobile
    ? `<span class="closeBtn">${tips}</span>`
    : `<svg class="closeBtn" @click="closeChatWin" viewBox="0 0 1024 1024">
        <use xlink:href="#icon-win-close"></use>
      </svg>`
  $div.innerHTML = `<div class="head">
    <span class="title moveWrap"><svg class="video-icon"><use xlink:href="#icon-video"></use></svg></span>
    <div class="ctrlWrap control"> ${btnHtml} </div>
  </div>
  <div class="body"></div>`
  $div.classList.add('c-win')
  document.getElementsByTagName('body')[0].prepend($div)
  if (isMobile) {
    $div.setAttribute('type', 'top')
  } else {
    BenModalFn.init($div, {})
  }
  const $close = $div.querySelector('.closeBtn') as HTMLElement
  $vCt = $div.querySelector(':scope > .body') as HTMLElement
  return { $div, $close, $vCt }
}
